import React from 'react';
import styled from '@emotion/styled';
import { jsx, css, keyframes } from '@emotion/react';

// theme
import { spacing, fontSizes, theme } from '../../utils';

const getPropsByVariant = ({ color }) => {
  const colorInPalette = theme.palette[color];

  // default
  const defaultProps = {
    main: {
      background: colorInPalette.main,
      fontSize: fontSizes['xmedium'],
      color: theme.palette.grey['800'],
      fontWeight: theme.typography.fontWeight.semibold,
      borderRadius: theme.shape.borderRadius.sm,
    },
  };
  return defaultProps.main;
};

const LabelWrapper = styled.span`
  height: 24px;
  line-height: 16px;
  display: inline-block;
  padding: 4px 8px;
`;

type LabelProps = {
  text: string;
  color: string;
};

export const Label: React.FC<LabelProps> = ({ color, text }) => {
  const propsByVariant = getPropsByVariant({ color });
  const styleLabel = propsByVariant;
  return (
    <>
      <LabelWrapper css={{ ...styleLabel }}>{text}</LabelWrapper>
    </>
  );
};

export default Label;
